import { FC, useMemo, useState, useEffect } from 'react'
import { LAYER_METAS } from 'constants/future'
import { FutureLayerUID, FutureLayer } from 'components/features/future/types'
import { FuturePanePreset } from 'components/features/future/FuturePanePreset/FuturePanePreset'
import * as yup from 'yup'
import { useLayerSelector, extendCommonSchema } from 'components/features/future/helpers'
import { FutureWhenInput } from 'components/features/future/FutureWhenInput/FutureWhenInput'
import { schemaNumber } from 'schemas/baseSchema'
import { SellAssetFields } from 'components/features/future/SellAssetFields/SellAssetFields'
import { schemaAssetSell } from 'schemas/futureSchema'
import { ObjectSchema } from 'yup'
import { useCollectLayerErrors } from 'components/features/future/hooks/useCollectErrors'
import { LayerStatus } from 'components/features/future/LayerStatus/LayerStatus'

const LAYER_SLUG = 'sell_car' as const
type LayerSlugType = typeof LAYER_SLUG
type LayerType = Extract<FutureLayer, { slug: LayerSlugType }>

const schemaCreator = extendCommonSchema<LayerSlugType>(
  yup
    .object()
    .concat(yup.object({
      sales_price: schemaNumber,
    }))
    .concat(schemaAssetSell) as ObjectSchema<LayerType>
)

type FutureLayerPaneSellCarProps = {
  uid?: FutureLayerUID
  onCancel: () => void
}

export const FutureLayerPaneSellCar: FC<FutureLayerPaneSellCarProps> = (props) => {
  const { onCancel, uid } = props
  const layer = useLayerSelector<LayerSlugType>(props)

  const { icon, name, type } = LAYER_METAS[LAYER_SLUG]

  return (
    <FuturePanePreset<LayerSlugType>
      layer={ layer }
      slug={ LAYER_SLUG }
      name={ name }
      icon={ icon }
      type={ type }
      schemaCreator={ schemaCreator }
      onCancel={ onCancel }
    >
      <FormFields uid={ uid } />
    </FuturePanePreset>
  )
}

type FormFieldsProps = {
  uid?: FutureLayerUID
}
const FormFields: FC<FormFieldsProps> = (props) => {
  const { uid } = props

  // Rerender first time to let useHints make first request. TODO: figure out why it works fine in Sell Home layer
  const [, render] = useState({})
  useEffect(() => render({}), [])

  const errors = useCollectLayerErrors<LayerType>()

  const sellFieldsChild = useMemo(() => (
    <SellAssetFields
      errors={ errors }
      uid={ uid }
      type='car'
    />
  ), [errors, uid])

  const completeChild = useMemo(() => (
    <>
      <h1>
        Event Completed
      </h1>
      Don't forget to update your Settings:
      <ul>
        <li>Unlink your old car to remove it from your Assets</li>
        <li>Unlink your old auto loan to remove it from your Debts</li>
      </ul>
    </>
  ), [])

  return (
    <LayerStatus uid={ uid || null } completeContent={ completeChild } skipPartialState type='event'>
      <FutureWhenInput error={ errors.whenField } />

      { sellFieldsChild }

    </LayerStatus>
  )
}
